"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Answer_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Answer = void 0;
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const rdf_1 = require("lincd-rdf/lib/ontologies/rdf");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
let Answer = Answer_1 = class Answer extends Shape_1.Shape {
    static loadAll() {
        return Server_1.Server.call(package_1.packageName, 'loadAll', Answer_1.shape.namedNode);
    }
    static fromQuoraResponse(answer) {
        const URI = process.env.DATA_ROOT + '/answer/' + answer.aid;
        const answerNode = models_1.NamedNode.getOrCreate(URI);
        answerNode.overwrite(rdf_1.rdf.type, titan_ads_1.titanAds.Answer);
        const newAnswer = new Answer_1(answerNode);
        if (newAnswer.url)
            return newAnswer;
        newAnswer.url = 'https://quora.com' + answer.permaUrl;
        newAnswer.id = answer.aid;
        return newAnswer;
    }
    get id() {
        return Number.parseInt(this.getValue(dcterms_1.dcterms.identifier));
    }
    set id(val) {
        this.overwrite(dcterms_1.dcterms.identifier, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get url() {
        return this.getValue(dcterms_1.dcterms.source);
    }
    set url(val) {
        this.overwrite(dcterms_1.dcterms.source, new models_1.Literal(val));
    }
};
exports.Answer = Answer;
Answer.targetClass = titan_ads_1.titanAds.Answer;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.identifier,
        required: true,
        maxCount: 1,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Answer.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.source,
        required: true,
        maxCount: 1,
        dataType: xsd_1.xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Answer.prototype, "url", null);
exports.Answer = Answer = Answer_1 = __decorate([
    package_1.linkedShape
], Answer);
//# sourceMappingURL=Answer.js.map